<template>
  <v-dialog
    id="confirm-dialog"
    v-model="display"
    class="modal-wrapper"
    width="500"
  >
    <v-card class="modal">
      <v-card-title class="headline">
        {{ $t(props.headline) }}
      </v-card-title>
      <v-card-text class="content">
        <v-row v-if="!props.alternative" class="text">{{ $tc(props.text, props.plurality) }}</v-row>
        <v-row v-else class="text">{{ props.text }}</v-row>
      </v-card-text>
      <v-card-actions class="actions">
        <v-btn
          id="confirm-dialog-continue"
          class="ctp-btn my-0 continue"
          text
          :loading="props.loading"
          rounded
          @click="props.actions.continue.caller"
        >
          {{ $t(props.actions.continue.text) }}
        </v-btn>
        <v-spacer />
        <v-btn
          id="confirm-dialog-cancel"
          class="cancel"
          text
          :loading="props.loading"
          rounded
          dark
          elevation="1"
          @click="props.actions.cancel.caller"
        >
          {{ $t(props.actions.cancel.text) }}
        </v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script setup lang="ts">
import { computed } from 'vue';

const props = defineProps({
  headline: {
    type: String,
    default: ''
  },
  text: {
    type: String,
    default: ''
  },
  plurality: {
    type: Number,
    default: 0
  },
  actions: {
    type: Object,
    default: () => ({})
  },
  initialDisplayState: {
    type: Boolean,
    default: false
  },
  alternative: {
    type: Boolean,
    default: false
  },

  loading: {
    type: Boolean,
    default: false
  }
});

const emit = defineEmits(['modal']);

const display = computed({
  get() {
    return props.initialDisplayState;
  },
  set(payload) {
    emit('modal', payload);
  }
});

</script>
<style lang="scss" scoped>
@import './styles/confirm-dialog.scss';
</style>
